import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
	text-align: left;
	padding: 30px 10vw;
	padding: 30px var(--side-margin);

	h1 {
		font-size: var(--fs-big);
		margin: 20px 0;
		text-align: center;

		strong {
			color: #FF9C46;
			color: var(--purple);
		}
	}

	h2 {
		margin: 20px 0 10px;
		font-size: var(--fs-big);
	}

	h3 {
		margin: 10px 0;
		font-size: var(--fs-medium);
	}

	ul {
		margin-left: 30px;
	}

	p {
		margin: 10px 0;
	}

	a {
		color: #ffaa66;
		color: var(--orange-light);
	}
`;

const TextSection = ({ input }) => {
	return <Wrapper dangerouslySetInnerHTML={{ __html: input }} />;
};

TextSection.propTypes = {
	input: PropTypes.string.isRequired
};

export default TextSection;



// WEBPACK FOOTER //
// ./src/components/TextSection.js